import a from"react";import e from"classnames";var r=function(r){var s=r.additionalClassNames,t=r.background,c=r.children,n=e("c-base-header",s);return a.createElement("header",{className:n,style:{background:t}},c)};export{r as BaseHeader};
//# sourceMappingURL=BaseHeader.js.map
